module.exports = __webpack_public_path__ + "img/logo_samara.737cca35.svg";